import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function StickyWidget() {
  const [isScrolled, setIsScrolled] = useState(false);
  const reduceMotion = useReducedMotion();
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isScrolled || answeredCount === 0) return null;
  const title = answeredCount >= 4 ? "You're halfway there" : 'Score started';
  const handleFinishClick = () => {
    openDiagnostic();
  };
  const dots = Array.from({
    length: 8
  });
  const enterClass = reduceMotion ? '' : 'animate-in fade-in slide-in-from-bottom-4 duration-500';
  const enterMobileClass = reduceMotion ? '' : 'animate-in slide-in-from-bottom-full duration-300';
  return <>
      {/* Desktop card — lower right, paper surface, calm progress cue */}
      <div className={`${enterClass} fixed bottom-8 right-8 z-50 hidden w-[19rem] flex-col gap-3.5 rounded-2xl border border-gray-200/70 bg-paper p-5 text-navy shadow-[0_24px_48px_-18px_rgba(26,40,56,0.28)] md:flex`} data-id="element-579" data-mp="36eehk70epptl">
        <div className="flex items-center justify-between gap-4" data-id="element-580" data-mp="3fgnraunupf5x">
          <div data-id="element-581" data-mp="2rps307ilt23f">
            <div className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-seaglass" data-id="element-582" data-mp="2rrl7ph9npc8s">
              {title}
            </div>
            <div className="text-sm font-medium text-text-muted" aria-live="polite" data-id="element-583" data-mp="2mpdw4ssqny6z">
              {answeredCount} of 8 answered
            </div>
          </div>
          <Cta variant="primary" size="sm" showArrow onClick={handleFinishClick} className="flex-shrink-0 shadow-none hover:shadow-none hover:translate-y-0" data-id="element-584" data-mp="2wouxiy0yjpx5">
            Finish
          </Cta>
        </div>
        {/* Segmented sea-glass progress cue — no ring, no meter */}
        <div className="flex items-center gap-1.5" aria-hidden="true" data-id="element-585" data-mp="7ycelzsx56ae">
          {dots.map((_, i) => <div key={i} className={`h-1.5 flex-1 rounded-full ${i < answeredCount ? 'bg-seaglass' : 'bg-gray-200'}`} data-id="element-586" data-mp="cwdzmq9wnfoi" data-mpi={i} />)}
        </div>
      </div>

      {/* Mobile bottom bar */}
      <div className={`${enterMobileClass} fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between border-t border-gray-200/70 bg-paper px-4 py-3 text-navy shadow-[0_-10px_30px_rgba(26,40,56,0.12)] md:hidden`} data-id="element-587" data-mp="hq05nzlkclbc">
        <div className="flex items-center gap-2 text-sm" data-id="element-588" data-mp="3q2xmoloef01u">
          <span className="font-semibold" data-id="element-589" data-mp="3q5jtgj3gtbj0">Score</span>
          <span className="text-gray-300" aria-hidden="true" data-id="element-590" data-mp="3u3zn35u1xi5e">&middot;</span>
          <span className="font-semibold text-seaglass" aria-live="polite" data-id="element-591" data-mp="2yhtkcvtrax9">{answeredCount}/8</span>
        </div>
        <Cta variant="primary" size="sm" showArrow onClick={handleFinishClick} className="min-h-[44px] shadow-none hover:shadow-none hover:translate-y-0" data-id="element-592" data-mp="19flcsuumb84v">
          Finish
        </Cta>
      </div>
    </>;
}